document.addEventListener('DOMContentLoaded', () => {
  let carousels = []
  const buildCarousels = () => {
    const carouselEls = document.querySelectorAll('[data-product-carousel]')
    carouselEls.forEach((carousel, i) => {
      const nextBtn = carousel.parentElement.querySelector('.swiper-button-next')
      const prevBtn = carousel.parentElement.querySelector('.swiper-button-prev')
      carousels[i] = new Swiper(carousel, {
        slidesPerView: 'auto',
        spaceBetween: 30,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        allowTouchMove: true,
        breakpoints: {
          320: {
          },
          480: {
          },
          1024: {
            allowTouchMove: true
          }
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        // scrollbar: {
        //   el: '.swiper-scrollbar',
        //   draggable: true,
        //   snapOnRelease: true,
        //   hide: true
        // }
      })
    })
  }
  const destroyCarousels = () => {
    carousels.forEach((c) => {
      c.destroy(true,true)
      carousels = []
    })
  }
  const handleResize = () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      if (carousels.length) return
      buildCarousels()
    } else {
      destroyCarousels()
    }
  }
  if (window.matchMedia('(min-width: 1024px)').matches) {
    buildCarousels()
  }
  window.addEventListener('resize', () => handleResize())
})